import { useLanguage } from '../../../contexts/useLanguage';
import officeImg from '../../../assets/readdy/search_office-hk-modern-team-unified-009__c92b8f7119.jpg';

export default function CompanyOverview() {
  const { t } = useLanguage();

  return (
    <section id="overview" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-32">
          <div className="space-y-8">
            <div>
              <p className="text-xs font-light text-gray-500 tracking-widest uppercase mb-3">
                {t('公司概况', 'Company Overview')}
              </p>
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                {t('立足双城优势，构建创新生态', 'Leveraging Dual-City Advantages to Build an Innovation Ecosystem')}
              </h2>
              <div className="w-20 h-1 bg-gradient-to-r from-gray-800 to-red-600 rounded-full"></div>
            </div>

            <div className="space-y-5">
              <div className="bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-3xl p-8 hover:shadow-xl transition-all border border-gray-200">
                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl flex-shrink-0 shadow-lg">
                    <i className="ri-map-pin-line text-3xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('地理优势', 'Geographic Advantage')}</h3>
                    <p className="text-base text-gray-700 leading-relaxed">
                      {t(
                        '立足香港国际金融中心与深圳科技创新中心，致力于打造融合AI技术、数字娱乐与东方文化的创新产品',
                        'Based in Hong Kong\'s international finance center and Shenzhen\'s tech innovation hub, we are committed to creating innovative products that integrate AI technology, digital entertainment, and Eastern culture'
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-3xl p-8 hover:shadow-xl transition-all border border-gray-200">
                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl flex-shrink-0 shadow-lg">
                    <i className="ri-lightbulb-flash-line text-3xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('智能创新生态', 'Smart Innovation Ecosystem')}</h3>
                    <p className="text-base text-gray-700 leading-relaxed">
                      {t(
                        '以AI原生引擎驱动企业进化，通过开放生态定义未来商业，树立企业新标杆。',
                        'Driven by AI-native engines for enterprise evolution, defining future business through open ecosystems, and establishing new enterprise benchmarks.'
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
              <img
                src={officeImg}
                alt="Company Office"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              
              <div className="absolute bottom-8 right-8 space-y-3">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl px-6 py-4 shadow-xl border border-gray-200">
                  <p className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-gray-900 bg-clip-text text-transparent">
                    {t('10万+', '100K+')}
                  </p>
                  <p className="text-xs text-gray-600">{t('日创作任务', 'Daily Creation Tasks')}</p>
                </div>
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl px-6 py-4 shadow-xl border border-red-100">
                  <p className="text-2xl font-bold bg-gradient-to-r from-red-600 to-red-700 bg-clip-text text-transparent">{t('数万', 'Tens of Thousands')}</p>
                  <p className="text-xs text-gray-600">{t('全球用户', 'Global Users')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Development Milestones - Independent Section */}
        <div className="mb-32">
          <div className="text-center mb-20">
            <p className="text-sm font-light text-orange-600 tracking-widest uppercase mb-4">
              {t('发展里程碑', 'Development Milestones')}
            </p>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">{t('发展里程碑', 'Development Milestones')}</h2>
            <div className="w-32 h-1.5 bg-gradient-to-r from-orange-500 to-red-600 rounded-full mx-auto"></div>
          </div>

          {/* Timeline Visualization */}
          <div className="relative max-w-6xl mx-auto">
            {/* Timeline Main Line */}
            <div className="absolute left-0 right-0 top-20 h-2 bg-gradient-to-r from-orange-300 via-orange-400 to-orange-500 rounded-full shadow-lg hidden md:block"></div>

            {/* Mobile Vertical Connector */}
            <div className="absolute left-1/2 top-12 bottom-12 w-2 -translate-x-1/2 bg-[#F16410] rounded-full shadow-lg md:hidden"></div>

            {/* Milestone Nodes */}
            <div className="relative grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {/* Late 2024 */}
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-full shadow-2xl mb-6 relative z-10 border-4 border-white">
                  <i className="ri-seedling-line text-4xl text-white"></i>
                </div>
                <div className="text-center bg-white rounded-2xl p-6 shadow-xl border-2 border-orange-200 hover:shadow-2xl transition-all">
                  <p className="text-base font-bold text-orange-600 mb-3">{t('2024年末', 'Late 2024')}</p>
                  <p className="text-sm text-gray-700 leading-tight font-medium">
                    {t('获得香港数码港CCMF种子基金', 'Received Hong Kong Cyberport CCMF Seed Fund')}
                  </p>
                </div>
              </div>

              {/* Mid 2025 */}
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-full shadow-2xl mb-6 relative z-10 border-4 border-white">
                  <i className="ri-funds-line text-4xl text-white"></i>
                </div>
                <div className="text-center bg-white rounded-2xl p-6 shadow-xl border-2 border-orange-200 hover:shadow-2xl transition-all">
                  <p className="text-base font-bold text-orange-600 mb-3">{t('2025年中', 'Mid 2025')}</p>
                  <p className="text-sm text-gray-700 leading-tight font-medium">
                    {t('获得香港科技署创新科及技基金', 'Received Hong Kong Innovation and Technology Fund')}
                  </p>
                </div>
              </div>

              {/* November 2025 */}
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-full shadow-2xl mb-6 relative z-10 border-4 border-white">
                  <i className="ri-trophy-line text-4xl text-white"></i>
                </div>
                <div className="text-center bg-white rounded-2xl p-6 shadow-xl border-2 border-orange-200 hover:shadow-2xl transition-all">
                  <p className="text-base font-bold text-orange-600 mb-3">{t('2025年11月', 'November 2025')}</p>
                  <p className="text-sm text-gray-700 leading-tight font-medium">
                    {t('获深港创新创业大赛三等奖', 'Won Third Prize in Shenzhen-Hong Kong Innovation Competition')}
                  </p>
                </div>
              </div>

              {/* Early 2026 */}
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-full shadow-2xl mb-6 relative z-10 border-4 border-white">
                  <i className="ri-building-2-line text-4xl text-white"></i>
                </div>
                <div className="text-center bg-white rounded-2xl p-6 shadow-xl border-2 border-orange-200 hover:shadow-2xl transition-all">
                  <p className="text-base font-bold text-orange-600 mb-3">{t('2026年初', 'Early 2026')}</p>
                  <p className="text-sm text-gray-700 leading-tight font-medium">
                    {t('成功入驻深港青年创新创业基地孵化', 'Successfully Entered Shenzhen-Hong Kong Youth Innovation Base Incubation')}
                  </p>
                </div>
              </div>

              {/* March 2026 */}
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-full shadow-2xl mb-6 relative z-10 border-4 border-white">
                  <i className="ri-team-line text-4xl text-white"></i>
                </div>
                <div className="text-center bg-white rounded-2xl p-6 shadow-xl border-2 border-orange-200 hover:shadow-2xl transition-all">
                  <p className="text-base font-bold text-orange-600 mb-3">{t('2026年3月', 'March 2026')}</p>
                  <p className="text-sm text-gray-700 leading-tight font-medium">
                    {t('与华南理工吴贤铭AI实验室达成战略合作', 'Reached Strategic Partnership with SCUT Wu Hsien-Ming AI Lab')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
